import jQuery from 'jquery';
let $ = jQuery;

import 'LIBS/jquery.placeholder.js';

import 'HSNDIR/Template.js';

/**
    * class HSN.Template.EmailCaptureCommon
    *
    * Encapsulates the common functionality for Email Capture.
    **/
HSN.Template.EmailCaptureCommon = function (config) {
    /**
        * new HSN.Template.EmailCaptureCommon(config)
        * - config (Object): A configuration object for the [[HSN.Template.EmailCaptureCommon]]
        *   consisting of the following keys:
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the template.
        *   - context (string): A string telling the template what context its being called under. Should be either MODAL|modal or DRAWER|drawer.
        **/

    var __scope = this;

    this._container = $(config.container);

    jQuery('input, textarea').placeholder();

    //These events are attached from the drawer, the modal's events are attached in EmailCaptureModal.js
    $('#capture-email-address-again').on('paste', this._container, function (e) {
        return false;
    });

    $('#capture-email-address-again').on('keyup', this._container, function (e) {
        var $this = $(this);
        if ($this.val() !== $('#capture-email-address').val()) {
            $this.addClass('invalid-email');
        } else {
            $this.removeClass('invalid-email');
        }
    });

    $('#capture-signup').on('click', this._container, function (e) {
        e.stopPropagation();
        e.preventDefault();
        var emailAddress = $('#capture-email-address').val();
        var emailAddressAgain = $('#capture-email-address-again').val();

        if (emailAddress === '' || emailAddress === null) {
            $('#capture-error').html('Please enter an email address.');
            $('#capture-email-address').addClass('invalid-email');
                return;
        }

        if (emailAddress !== emailAddressAgain) {
            $('#capture-error').html('Your email and confirm email do not match.');
            $('#capture-email-address-again').each(function () {
                $(this).addClass('invalid-email');
            });
            return;
        }

        cmCreateManualLinkClickTag('/email-capture-drawer?cm_sp=EmailCapture-_-Drawer-_-15Off&cm_re=EmailCapture-_-Drawer-_-15Off', 'EmailCapture15Off');
        var config = {};
        config.success = function (data) {
            __scope.HandleDrawerThanks();
        };
        config.error = function () {
            alert('We\'re sorry, there was a problem saving your email address. Please try again later.');
        }
        HSN.Instance().HandleEmailSignup(emailAddress, 56, config)
    });

    $('#capture-no-thanks').on('click', this._container, function (e) {
        e.stopPropagation();
        e.preventDefault();
        var callback = function () {
            HSN.Instance().AccountNavigation.Cabinet.Close(null);
            cmCreateManualLinkClickTag('/email-capture-drawer?cm_sp=EmailCapture-_-Drawer-_-NoThanks&cm_re=EmailCapture-_-Drawer-_-NoThanks', 'EmailCaptureNoThanks');
        };
        __scope.HandleNoThanks(callback);
    });

    $('#capture-shop-now').on('click', this._container, function (e) {
        e.stopPropagation();
        e.preventDefault();
        HSN.Instance().AccountNavigation.Cabinet.Close(null);
    });
};
HSN.Template.EmailCaptureCommon.prototype =
    {
        HandleNoThanks: function (callback) {
            HSN.Template.EmailCaptureCommon.prototype.AjaxSend('/account/emailcapture/no-thanks', 'POST', 'json', {}, {});
            if (callback) {
                callback();
            }
        },
        HandleDrawerThanks: function () {
            var config = {};
            config.callback = function (data) {
                //change out drawer content here
                $('#cabinet .content').html(data);
            };
            HSN.Template.EmailCaptureCommon.prototype.AjaxSend('/account/emailcapture/thanks', 'GET', 'html', {}, config);
        },
        AjaxSend: function (url, type, dataType, reqData, config) {
            url = url + '?_ts' + new Date().getTime();
            $.ajax
            (
                url,
                {
                    context: this,
                    dataType: dataType,
                    type: type,
                    data: reqData,
                    success: function (data) {
                        if (config && config.callback) {
                            config.callback(data);
                        }
                    },
                    error: function () {
                        alert('Unfortunately there was an error, please try again.');
                    }
                }
            );
        }
    };




// WEBPACK FOOTER //
// ./assets/js/HSN/Template/EmailCaptureCommon.js